import { TextField } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface VoucherInputFieldProps {
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setError: (error: boolean) => void;
  setLocalErrorMessage: (message: string) => void;
  error: boolean;
  localErrorMessage: string;
  errorMessage?: any;
  voucherCode?: string | undefined;
}

export default function VoucherInputField({
  handleInputChange,
  errorMessage,
  voucherCode,
  error,
  localErrorMessage,
  setError,
  setLocalErrorMessage,
}: VoucherInputFieldProps) {
  const { t } = useTranslation();

  useEffect(() => {
    if (errorMessage) {
      setError(true);
      setLocalErrorMessage(errorMessage);
    }
  }, [errorMessage, localErrorMessage, setError, setLocalErrorMessage]);

  return (
    <TextField
      placeholder={t("BuyVoucherPrompt.applyVoucherCode.placeholder")}
      variant="outlined"
      fullWidth
      value={voucherCode}
      onChange={handleInputChange}
      error={error}
      helperText={error && localErrorMessage}
      slotProps={{
        input: {
          sx: {
            "&::placeholder": {
              fontSize: 2,
              color: "neutral.light",
            },
          },
          "aria-label": t(
            "AddOrUseVoucher.Voucher.UseVoucherTab.codeInput.label"
          ),
        },
      }}
      sx={{
        borderColor: "neutral.light",
        borderRadius: "5px",
        fontSize: "12px",
      }}
    />
  );
}
